import React, { useEffect } from 'react'
import { Button, Container, Grid, makeStyles, Typography } from '@material-ui/core'
import { useForm } from '../../../hooks/useForm';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { useParams } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: '100%',
        marginTop: "1.5rem",
        marginBottom: "1rem"
    },
    title: {
        fontWeight: "bold"
    },
    submit: {
        marginTop: "1rem",
        textTransform: "none"
    }
}));

const MiPerfil = (props) => {
    const classes = useStyles()
    const { idUsuario, dataAfiliado } = props
    const { idAfiliado: idAfiliadoTurno } = useParams();

    const initialState = {
        oldPassword: "",
        password: "",
        confirmPassword: "",
        mail: dataAfiliado.domiciliosAfiliados.mail,
        telefono: dataAfiliado.domiciliosAfiliados.telefono,
        celular: dataAfiliado.domiciliosAfiliados.celular
    };

    const [formValues, handleInputChange, reset] = useForm(initialState);
    const { oldPassword, password, confirmPassword, mail, telefono, celular } = formValues;

    const handleSubmitResetPassword = async (e) => {
        e.preventDefault()
        const data = {
            idUsuario: idUsuario,
            oldPassword: oldPassword,
            newPassword: password,
            confirmPassword: confirmPassword
        }
        props.handleResetPassword(data, () => reset(initialState))
    }

    const handleSubmitChangeDataContacto = async (e) => {
        e.preventDefault()
        const data = {
                email:mail,
                telefono,
                celular
        }
        props.handleChangeDataContacto(data)
    }

    useEffect(() => {
        // custom rule will have name 'isPasswordMatch'
        ValidatorForm.addValidationRule('isPasswordMatch', (value) => {
            if (value !== password) {
                return false;
            }
            return true;
        });
    })

    return (
        <div className={classes.root}>
            <Container maxWidth="md">
                <Typography align="center" variant="h4" color="primary" className={classes.title}>{idAfiliadoTurno ? "Cambiar datos de contacto" : "Mi perfil"}</Typography>
                <Grid
                    container
                    direction="row"
                    alignItems="center"
                    style={{ marginTop: "1rem" }}
                >
                    {
                        idAfiliadoTurno &&
                        <Grid item xs={12} md={3}></Grid>
                    }

                    <Grid item xs={12} md={idAfiliadoTurno ? 6 : 5}>
                        {
                            !idAfiliadoTurno &&
                            <Typography align="center" variant="h6" color="secondary">Datos de contacto</Typography>
                        }
                        <ValidatorForm onSubmit={handleSubmitChangeDataContacto}>
                            <TextValidator
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                label="Correo electrónico*"
                                onChange={handleInputChange}
                                name="mail"
                                type="email"
                                validators={['required']}
                                errorMessages={['El correo electrónico es requerido']}
                                value={mail}
                            />
                            <TextValidator
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                label="Cel. (10 dig. sin 0 ni 15)*"
                                onChange={handleInputChange}
                                name="celular"
                                //type="number"
                                value={celular}
                                validators={[
                                    "required",
                                    "isNumber",
                                    "maxNumber:9999999999",
                                    "minNumber:999999999",
                                ]}
                                errorMessages={[
                                    "El campo es requerido",
                                    "Solo numeros",
                                    "Verifique su telefono",
                                    "Verifique su telefono",
                                ]}
                            />
                            <TextValidator
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                label="Tel. (10 digitos sin 0)"
                                onChange={handleInputChange}
                                name="telefono"
                                //type="number"
                                value={telefono}
                                validators={[
                                    "isNumber",
                                    "maxNumber:9999999999",
                                    "minNumber:999999999",
                                ]}
                                errorMessages={[
                                    "Solo numeros",
                                    "Verifique su telefono",
                                    "Verifique su telefono",
                                ]}
                            />
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                color="primary"
                                className={classes.submit}
                            >
                                Actualizar datos
                            </Button>
                        </ValidatorForm>
                    </Grid>

                    <Grid item xs={12} md={idAfiliadoTurno ? 3 : 2}></Grid>
                    {
                        !idAfiliadoTurno &&
                        <Grid item xs={12} md={5}>
                        <Typography align="center" variant="h6" color="secondary">Contraseña</Typography>
                            <ValidatorForm onSubmit={handleSubmitResetPassword}>
                                <TextValidator
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                    label="Contraseña actual"
                                    onChange={handleInputChange}
                                    name="oldPassword"
                                    type="password"
                                    validators={['required']}
                                    errorMessages={['La actual contraseña es requerida']}
                                    value={oldPassword}
                                />
                                <TextValidator
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                    label="Nueva contraseña"
                                    onChange={handleInputChange}
                                    name="password"
                                    type="password"
                                    validators={['required']}
                                    errorMessages={['La nueva contraseña es requerida']}
                                    value={password}
                                />
                                <TextValidator
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                    label="Confirmación nueva contraseña"
                                    onChange={handleInputChange}
                                    name="confirmPassword"
                                    type="password"
                                    validators={['isPasswordMatch', 'required']}
                                    errorMessages={['Las nuevas contraseñas deben ser iguales', 'La confirmación de la nueva contraseña es requerida']}
                                    value={confirmPassword}
                                />

                                <Button
                                    type="submit"
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    className={classes.submit}
                                >
                                    Actualizar contraseña
                                </Button>
                            </ValidatorForm>
                        </Grid>
                    }
                </Grid>
            </Container>
        </div>
    )
}

export default MiPerfil
